import { compose } from 'recompose';
import { themr } from '@friendsofreactjs/react-css-themr';
import { connect } from 'react-redux';

import { selectors as subscriptionSelectors } from '../../../../../redux/subscription';
import intlEquipped from '../../../../../hocs/intlEquipped';
import DeliveryDetails from './DeliveryDetails';
import { fetchSubscriptionDelivery } from '../../../../../redux/subscription/actions';

const mapStateToProps = (state, ownProps) => {
    const subscriptionDelivery = subscriptionSelectors.getSubscriptionDelivery(state, ownProps.subscriptionId);

    return {
        fetching: subscriptionDelivery?.fetching,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchDeliveries: () => dispatch(fetchSubscriptionDelivery({ subscriptionId: ownProps.subscriptionId })),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    themr('SapiSubscriptionModuleDeliveryDetails'),
    intlEquipped
)(DeliveryDetails);
